import React, { Component } from 'react';

import classNames from 'classnames'
import styles from './index.css';
import Header from '../../components/Header'; 
import MainContent from '../../components/MainContent';

import Meta from '../../components/Meta';

let maxScroll = 0;
let kitchenScroll = 0;

// let canScroll = true;
// let scrollings = [];
// let prevTime = 0;
// let isSafari = false;
// let timeStamp = 0;

export default class MainPage extends Component {  
  state={
    stateScroll: 0,
    stepTemp: 3,
    valueScroll:0,
    hideArrowAbout: false,
    hideArrowHistory: false,
    steps : {
      1:true,
      2:false,
      3:false,
      4:false,
      5:false,
      6:false,
      7:false,
      8:false,
      9:false,
      10:false
    }
  }
  componentWillMount(){
    document.documentElement.scrollTop = 0;
  }
  componentDidMount(){
    //Первые 2 шага    
    setTimeout(()=>{
      let stepsTemp=this.state.steps;
      stepsTemp[1] = false;
      stepsTemp[2] = true;
      stepsTemp[10] = true;
      this.setState({
        steps:stepsTemp
      },()=>setTimeout(()=>{
        let stepsTemp = this.state.steps;
        stepsTemp[2] = false;
        stepsTemp[3] = true;
        this.setState({
          steps:stepsTemp
        })
      },800))      
    },600);
  }
  componentDidUpdate(prevProps){
    // console.log(prevProps.scrollId+' o - n '+this.props.scrollId);
    if(!(prevProps.scrollId===this.props.scrollId)){
      this.scrollFunction(this.props.scrollY);
    }
  }
  mobile(){
    if(document.documentElement.clientWidth < 1025) return true;
    return false;
  }
  
  scrollFunction(e){
    if(!this.state.hideArrowAbout && (this.state.stepTemp>3)){
      this.setState({hideArrowAbout:true})
    }
    if(!this.state.hideArrowHistory && (this.state.stepTemp>5)){
      this.setState({hideArrowHistory:true})
    }
    // Анимация вниз
    if( (e.deltaY>0)&&(this.state.stepTemp<7)) {
      let stepsTemp = this.state.steps;
      stepsTemp[this.state.stepTemp+1] = true;
      this.setState({steps:stepsTemp,stepTemp:this.state.stepTemp+1})   
      return false;   
    }else 
    // Анимация верх
    if( (e.deltaY<0)&&(this.state.stepTemp>3)&&(this.state.stepTemp<8)){
      let stepsTemp = this.state.steps;
      stepsTemp[this.state.stepTemp]   = false;
      this.setState({steps:stepsTemp,stepTemp:this.state.stepTemp-1})
      return false;
    }

    // Cкрол вниз
    if( (e.deltaY>0)&&(this.state.stepTemp>6)&&(this.state.valueScroll>(maxScroll + document.documentElement.offsetHeight))) {
      kitchenScroll = this.state.valueScroll-(maxScroll + document.documentElement.offsetHeight);
      this.setState({
        stepTemp:this.state.stepTemp+1,
        valueScroll: this.state.valueScroll-kitchenScroll
      })   
      return false;
    }
    // Cкрол вверх
    if( (e.deltaY<0)&&(this.state.stepTemp>6)) {
      this.setState({
        stepTemp:this.state.stepTemp-1,
        valueScroll: this.state.valueScroll+kitchenScroll
      })   
      return false;
    }
  }  
  
  getHeightHistory = height =>{ 
    return height; 
  }
  getHeightKitchen = height =>{
    maxScroll = -(height + 80);
    return height;
  }  
  scrollDown = () =>{
    if(this.state.stepTemp === 3 || this.state.stepTemp === 5){
      let stepsTemp = this.state.steps;
      stepsTemp[this.state.stepTemp+1] = true;
      this.setState({steps:stepsTemp, stepTemp:this.state.stepTemp+1})
    }
  }
  render() {
    return (
      <div className={classNames(styles['index'], this.mobile() && styles['is-mobile'])} >
        <Meta/>
        <Header 
            steps   = {this.state.steps}
            isMain  = {true}  
            menu      = {this.props.menu} 
        />
        <MainContent 
            data              = {this.props.data}
            stateScroll       = {this.state.stateScroll} 
            steps             = {this.state.steps}
            getHeightHistory  = {this.getHeightHistory}
            getHeightKitchen  = {this.getHeightKitchen}
            valueScroll       = {this.state.valueScroll}
            hideArrowAbout    = {this.state.hideArrowAbout}
            hideArrowHistory  = {this.state.hideArrowHistory}
            handleScrollDown  = {this.scrollDown}
            ADMIN_URL         = {this.props.ADMIN_URL}
        />                                  
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/pages/Main/index.js